import nodeAPI from './ApiServiceNode';

const demographicsService = {
    /**
     * Get workforce demographics snapshot for a given date.
     * @param {string} [date] - YYYY-MM-DD format, defaults to today on server
     * @returns {Promise<Object>} demographics data
     */
    getSnapshot: async (date) => {
        const params = {};
        if (date) params.date = date;
        const response = await nodeAPI.get('/demographics/snapshot', { params });
        return response.data.data?.demographics || response.data.demographics;
    },

    /**
     * Get employee drill-down list for a specific dimension/value.
     * @param {string} date - YYYY-MM-DD
     * @param {string} dimension - 'all','gender','age','tenure','department','office'
     * @param {string|number|null} value - segment value or ID
     * @param {Object} [options]
     * @param {number} [options.page=1]
     * @param {number} [options.limit=100]
     * @param {string} [options.search]
     * @returns {Promise<Object>} { employees, pagination, filter }
     */
    getDrilldown: async (date, dimension, value, { page = 1, limit = 100, search } = {}) => {
        const params = { dimension, page, limit };
        if (date) params.date = date;
        if (value !== undefined && value !== null) params.value = value;
        if (search) params.search = search;
        const response = await nodeAPI.get('/demographics/breakdown', { params });
        return response.data.data || response.data;
    },
};

export default demographicsService;
